import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_REJECT_PHARMACY_ORDER } from "../../action-types/actions";

import i18n from "../../i18n";
export const rejectPharmacyOrder = createAsyncThunk(
  ACTIONS_REJECT_PHARMACY_ORDER.reject_order,
  async (arg, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    // Support both signatures: a plain orderId (legacy callers) or an object
    // { orderId, reason } where the rejection reason is optional.
    const orderId = typeof arg === "object" && arg !== null ? arg.orderId : arg;
    const reason =
      typeof arg === "object" && arg !== null ? arg.reason || "" : "";

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.rejectPharmacyOrder}/${orderId}/reject`,
        { reason },
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(i18n.t("pharmacy.toast.orderRejectedSuccessfully"));
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("pharmacy.toast.orderRejectionFailed"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorRejectingOrder");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
